// extracted by mini-css-extract-plugin
export default {"container":"RtxT4S","containerExtraSpacing":"Qr5cy2"};